<template>
  <div class="modal fade" id="modalEditInvoiceTag" role="dialog">
    <div
      class="modal-dialog modal-dialog-centered modal-scroll inter-font"
      style="max-width: 60%"
    >
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <div class="change-title">
            <h4 class="modal-title black-text" style="font-weight: bold">
              {{ modalTitle }}
            </h4>
          </div>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            @click="($event) => closeModal('close', false)"
          >
            &times;
          </button>
        </div>
        <div
          v-if="currentStep === 1"
          class="modal-body position-relative"
          style="font-size: 0.875rem"
        >
          <div
            v-if="isFinishGetDetail === false"
            class="position-absolute"
            style="
              top: 0;
              left: -14.7px;
              z-index: 99;
              padding: 0 1rem;
              width: 104%;
              height: 100%;
            "
          >
            <div
              class="d-flex align-items-center justify-content-center flex-column w-100 h-100"
              style="background-color: rgba(0, 0, 0, 0.6)"
            >
              <img src="~@/assets/images/2.gif" style="height: 44px" />
              <p class="text-light" style="font-size: 1rem">Loading Data</p>
            </div>
          </div>
          <div class="container">
            <div class="border rounded mb-2">
              <div
                class="px-4 py-2 border-bottom rounded-top"
                style="background-color: #f8f9fb"
              >
                <div class="d-flex" style="gap: 10px">
                  <img src="~@/assets/icon/mdi_finance.svg" />
                  <h5 class="modal-title black-text" style="font-weight: bold">
                    Sales
                  </h5>
                </div>
              </div>
              <div class="pl-4 pr-2 py-2">
                <div v-for="(item, index) in salesForm" :key="index">
                  <div class="row w-100 align-items-center">
                    <label class="col-4">{{ item.name }}</label>
                    <div class="col-8" style="gap: 10px">
                      <multiselect
                        v-model="item.selected"
                        :options="item.value"
                        label="label"
                        select-label=""
                        deselect-label=""
                        :allow-empty="false"
                        track-by="tagId"
                        :multiple="true"
                        @select="($event) => handleSelect($event, item.name)"
                        :style="
                          errorFields.indexOf(item.name) >= 0
                            ? 'border: 1px solid red; border-radius:5px'
                            : ''
                        "
                      >
                      </multiselect>
                      <p
                        v-if="errorFields.indexOf(item.name) >= 0"
                        class="text-danger error-text mb-0 mt-1"
                      >
                        Tidak boleh kosong
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="border rounded mb-2">
              <div class="px-4 py-2 border-bottom bg-light rounded-top">
                <div class="d-flex" style="gap: 10px">
                  <img src="~@/assets/icon/ic_outline-attach-money.svg" />
                  <h5 class="modal-title black-text" style="font-weight: bold">
                    Finance
                  </h5>
                </div>
              </div>
              <div class="relative finance-field-container">
                <div class="pl-4 pr-2 py-2">
                  <div class="row w-100 mb-2">
                    <div class="col-4">
                      <label>Billing</label>
                    </div>
                    <div class="col-8 order_tag_input" style="gap: 10px">
                      <multiselect
                        :value="billingValue"
                        :options="billingOptions"
                        @remove="($event) => handleRemove($event, 'billing')"
                        label="label"
                        select-label=""
                        deselect-label=""
                        :allow-empty="true"
                        track-by="tagId"
                        :multiple="true"
                        @select="($event) => handleSelect($event, 'billing')"
                        :style="
                          errorFields.indexOf('billing') >= 0 ||
                          errorFields.indexOf('billingTagError') >= 0
                            ? 'border: 1px solid red; border-radius:5px'
                            : ''
                        "
                      >
                      </multiselect>
                      <p
                        v-if="errorFields.indexOf('billing') >= 0"
                        class="text-danger error-text mb-0 mt-1"
                      >
                        Tidak boleh kosong
                      </p>
                      <p
                        v-if="errorFields.indexOf('billingTagError') >= 0"
                        class="text-danger error-text mb-0 mt-1"
                      >
                        Tag “–” tidak bisa dikombinasikan dengan tag lain.
                        Hilangkan tag "-" untuk melakukan kombinasi tag lainnya.
                      </p>
                      <div class="rounded bg-light mt-2 d-flex p-2 text-grey">
                        <i
                          class="bi bi-exclamation-circle"
                          style="font-size: 12px"
                        ></i>
                        <p
                          v-html="billingTooltip"
                          class="m-0 ml-2"
                          style="font-size: 12px"
                        ></p>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div class="row w-100">
                    <div class="col-4">
                      <label>Due Date</label>
                    </div>
                    <div class="col-8 order_tag_input">
                      <multiselect
                        v-model="dueDateValue"
                        :options="dueDateOptions"
                        label="label"
                        select-label=""
                        deselect-label=""
                        :allow-empty="false"
                        track-by="tagId"
                        placeholder="-"
                        @select="($event) => handleSelect($event, 'dueDate')"
                        :style="
                          errorFields.indexOf('dueDate') >= 0
                            ? 'border: 1px solid red; border-radius:5px'
                            : ''
                        "
                      >
                      </multiselect>
                      <p
                        v-if="errorFields.indexOf('dueDate') >= 0"
                        class="text-danger error-text mb-0 mt-1"
                      >
                        Tidak boleh kosong
                      </p>
                    </div>
                  </div>
                  <div
                    v-if="dueDateValue && dueDateValue.tagId === 159"
                    class="row w-100 align-items-center mt-2"
                  >
                    <label class="col-4">Custom Due Date</label>
                    <div class="col-3 input_number" style="gap: 10px">
                      <input
                        v-model="customDueDate"
                        type="number"
                        placeholder="-"
                        @change="
                          ($event) => handleChangeInput($event, 'customDueDate')
                        "
                        class="form-control"
                        :style="
                          errorFields.indexOf('customDueDate') >= 0
                            ? 'border: 1px solid red; border-radius:5px'
                            : ''
                        "
                      />
                      <p
                        v-if="errorFields.indexOf('customDueDate') >= 0"
                        class="text-danger error-text mb-0 mt-1"
                      >
                        Tidak boleh kosong
                      </p>
                    </div>
                  </div>
                  <div class="row w-100 mb-2">
                    <div class="col-4"></div>
                    <div class="col-8">
                      <div class="rounded bg-light mt-2 d-flex p-2 text-grey">
                        <i
                          class="bi bi-exclamation-circle"
                          style="font-size: 12px"
                        ></i>
                        <p
                          v-html="dueDateTooltip"
                          class="m-0 ml-2"
                          style="font-size: 12px"
                        ></p>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div class="row w-100">
                    <div class="col-4">
                      <label>Billed Per</label>
                    </div>
                    <div class="col-8 order_tag_input" style="gap: 10px">
                      <multiselect
                        :value="billedPerValue"
                        :options="billedPerOptions"
                        label="label"
                        select-label=""
                        deselect-label=""
                        :allow-empty="false"
                        track-by="tagId"
                        placeholder="-"
                        @select="($event) => handleSelect($event, 'billedPer')"
                        :style="
                          errorFields.indexOf('billedPer') >= 0
                            ? 'border: 1px solid red; border-radius:5px'
                            : ''
                        "
                      >
                      </multiselect>
                      <p
                        v-if="errorFields.indexOf('billedPer') >= 0"
                        class="text-danger error-text mb-0 mt-1"
                      >
                        Tidak boleh kosong
                      </p>
                    </div>
                  </div>
                  <div
                    v-if="billedPerValue && billedPerValue.tagId === 167"
                    class="row w-100 align-items-center mt-2"
                  >
                    <label class="col-4">Upfront</label>
                    <div class="row col-8" style="padding-right: 0">
                      <div class="col-4">
                        <multiselect
                          v-model="upfrontValue"
                          :options="upfrontOptions"
                          label="label"
                          select-label=""
                          deselect-label=""
                          selected-label=""
                          placeholder="-"
                          @select="($event) => handleSelect($event, 'upfront')"
                          :allow-empty="false"
                          track-by="tagId"
                          :style="
                            errorFields.indexOf('upfront') >= 0
                              ? 'border: 1px solid red; border-radius:5px'
                              : ''
                          "
                        >
                        </multiselect>
                      </div>
                      <div class="col-8" style="padding: 0">
                        <date-picker
                          :style="`width: 100%; ${
                            errorFields.indexOf('billingDate') >= 0 ||
                            errorFields.indexOf('billingDateBackdated') >= 0
                              ? 'border: 1px solid red; border-radius:5px'
                              : ''
                          }`"
                          v-model="billingDate"
                          type="date"
                          :editable="false"
                          :disabled-date="disabledDate"
                          format="DD-MM-YYYY"
                          placeholder="dd-mm-yyyy"
                          @change="handleChangeInput($event, 'billingDate')"
                        ></date-picker>
                      </div>
                      <div
                        v-if="errorFields.indexOf('billingDate') >= 0"
                        class="col-12"
                      >
                        <p class="text-danger error-text mb-0 mt-1">
                          Tidak boleh kosong
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="upfrontValue && upfrontValue.tagId === 16"
                    class="row w-100 align-items-center mt-2"
                  >
                    <div class="col-4"></div>
                    <div class="row col-8" style="padding-right: 0">
                      <div class="col-4">
                        <input
                          value="10%"
                          type="text"
                          disabled
                          class="form-control date_input"
                          style="height: 100%"
                        />
                      </div>
                      <div class="col-8" style="padding: 0">
                        <date-picker
                          :style="`width: 100%; ${
                            errorFields.indexOf('billingDate10') >= 0 ||
                            errorFields.indexOf('billingDate10Backdated') >= 0
                              ? 'border: 1px solid red; border-radius:5px'
                              : ''
                          }`"
                          v-model="billingDate10"
                          type="date"
                          :editable="false"
                          :disabled-date="disabledDate"
                          format="DD-MM-YYYY"
                          placeholder="dd-mm-yyyy"
                          @change="handleChangeInput($event, 'billingDate10')"
                        ></date-picker>
                      </div>
                      <div
                        v-if="errorFields.indexOf('billingDate') >= 0"
                        class="col-12"
                      >
                        <p class="text-danger error-text mb-0 mt-1">
                          Tidak boleh kosong
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="row mb-2 w-100">
                    <div class="col-4"></div>
                    <div class="col-8">
                      <div class="rounded bg-light mt-2 d-flex p-2 text-grey">
                        <i
                          class="bi bi-exclamation-circle"
                          style="font-size: 12px"
                        ></i>
                        <p
                          v-html="billedPerTooltip"
                          class="m-0 ml-2"
                          style="font-size: 12px"
                        ></p>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div class="row w-100 mb-2">
                    <div class="col-4">
                      <label>Billing Calculation </label>
                    </div>
                    <div class="col-8 order_tag_input" style="gap: 10px">
                      <multiselect
                        :value="billingCalculationValue"
                        :options="billingCalculationOptions"
                        label="label"
                        select-label=""
                        deselect-label=""
                        :allow-empty="false"
                        track-by="tagId"
                        placeholder="-"
                        @select="
                          ($event) => handleSelect($event, 'billingCalculation')
                        "
                        :disabled="
                          billedPerValue && billedPerValue.tagId === 167
                        "
                        :style="
                          errorFields.indexOf('billingCalculation') >= 0
                            ? 'border: 1px solid red; border-radius:5px'
                            : ''
                        "
                      >
                      </multiselect>
                      <p
                        v-if="errorFields.indexOf('billingCalculation') >= 0"
                        class="text-danger error-text mb-0 mt-1"
                      >
                        Tidak boleh kosong
                      </p>
                      <div class="rounded bg-light mt-2 d-flex p-2 text-grey">
                        <i
                          class="bi bi-exclamation-circle"
                          style="font-size: 12px"
                        ></i>
                        <p
                          v-html="billingCalculationTooltip"
                          class="m-0 ml-2"
                          style="font-size: 12px"
                        ></p>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div class="row w-100">
                    <div class="col-4">
                      <label>Recurring Billing Day</label>
                    </div>
                    <div class="col-8 order_tag_input" style="gap: 10px">
                      <multiselect
                        v-model="recurringBillingDayValue"
                        :options="recurringBillingDayOptions"
                        label="label"
                        select-label=""
                        deselect-label=""
                        :allow-empty="false"
                        track-by="tagId"
                        placeholder="-"
                        :disabled="
                          billedPerValue && billedPerValue.tagId === 167
                        "
                        @select="
                          ($event) =>
                            handleSelect($event, 'recurringBillingDay')
                        "
                        :style="
                          errorFields.indexOf('recurringBillingDay') >= 0
                            ? 'border: 1px solid red; border-radius:5px'
                            : ''
                        "
                      >
                      </multiselect>
                      <p
                        v-if="errorFields.indexOf('recurringBillingDay') >= 0"
                        class="text-danger error-text mb-0 mt-1"
                      >
                        Tidak boleh kosong
                      </p>
                    </div>
                  </div>
                  <div
                    v-if="
                      recurringBillingDayValue &&
                      recurringBillingDayValue.tagId === 164
                    "
                    class="row w-100 align-items-center"
                  >
                    <label class="col-4">Custom Recurring Billing Day</label>
                    <div class="col-8 row align-items-center input_number">
                      <p class="mb-0 col-2">Every</p>
                      <input
                        v-model="customRecurringBillingDay"
                        type="number"
                        placeholder="-"
                        @change="
                          ($event) =>
                            handleChangeInput(
                              $event,
                              'customRecurringBillingDay'
                            )
                        "
                        class="form-control col-3"
                        :disabled="
                          billedPerValue && billedPerValue.tagId === 167
                        "
                        :style="
                          errorFields.indexOf('customRecurringBillingDay') >= 0
                            ? 'border: 1px solid red; border-radius:5px'
                            : ''
                        "
                      />
                      <p class="mb-0 col-5">of the month</p>
                      <div
                        v-if="
                          errorFields.indexOf('customRecurringBillingDay') >= 0
                        "
                        class="col-12"
                      >
                        <p class="text-danger error-text mb-0 mt-1">
                          Tidak boleh kosong
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="row w-100 mb-2">
                    <div class="col-4"></div>
                    <div class="col-8">
                      <div class="rounded bg-light mt-2 d-flex p-2 text-grey">
                        <i
                          class="bi bi-exclamation-circle"
                          style="font-size: 12px"
                        ></i>
                        <p
                          v-html="recurringBillingDayTooltip"
                          class="m-0 ml-2"
                          style="font-size: 12px"
                        ></p>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div class="row w-100 mb-2">
                    <div class="col-4">
                      <label>Billing Start</label>
                    </div>
                    <div class="col-8">
                      <div
                        class="d-flex align-items-center order_tag_input"
                        style="gap: 10px"
                      >
                        <multiselect
                          :value="billingStartValue"
                          :options="billingStartOptions"
                          label="label"
                          select-label=""
                          deselect-label=""
                          :allow-empty="false"
                          track-by="tagId"
                          placeholder="-"
                          @select="
                            ($event) => handleSelect($event, 'billingStart')
                          "
                          :disabled="
                            billedPerValue && billedPerValue.tagId === 167
                          "
                          :style="
                            errorFields.indexOf('billingStart') >= 0
                              ? 'border: 1px solid red; border-radius:5px'
                              : ''
                          "
                        >
                        </multiselect>
                      </div>
                      <p
                        v-if="errorFields.indexOf('billingStart') >= 0"
                        class="text-danger error-text mb-0 mt-1"
                      >
                        Tidak boleh kosong
                      </p>
                      <div class="rounded bg-light mt-2 d-flex p-2 text-grey">
                        <i
                          class="bi bi-exclamation-circle"
                          style="font-size: 12px"
                        ></i>
                        <p
                          v-html="billingStartTooltip"
                          class="m-0 ml-2"
                          style="font-size: 12px"
                        ></p>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div class="row w-100 mb-2">
                    <label class="col-4">Invoice Type</label>
                    <div class="col-8 order_tag_input" style="gap: 10px">
                      <multiselect
                        v-model="invoiceTypeValue"
                        :options="invoiceTypeOptions"
                        label="label"
                        select-label=""
                        deselect-label=""
                        :allow-empty="false"
                        track-by="tagId"
                        placeholder="-"
                        @select="
                          ($event) => handleSelect($event, 'invoiceType')
                        "
                        :style="
                          errorFields.indexOf('invoiceType') >= 0
                            ? 'border: 1px solid red; border-radius:5px'
                            : ''
                        "
                      >
                      </multiselect>
                      <p
                        v-if="errorFields.indexOf('invoiceType') >= 0"
                        class="text-danger error-text mb-0 mt-1"
                      >
                        Tidak boleh kosong
                      </p>
                    </div>
                  </div>
                  <hr />
                  <div class="row w-100 align-items-center mb-2">
                    <label class="col-4">Additional Request/Doc</label>
                    <div class="col-8 order_tag_input" style="gap: 10px">
                      <multiselect
                        v-model="additionalReqOrDocValue"
                        :options="additionalReqOrDocOptions"
                        label="label"
                        select-label=""
                        deselect-label=""
                        :allow-empty="false"
                        track-by="tagId"
                        placeholder="-"
                        @select="
                          ($event) => handleSelect($event, 'additionalReqOrDoc')
                        "
                        :style="
                          errorFields.indexOf('additionalReqOrDoc') >= 0
                            ? 'border: 1px solid red; border-radius:5px'
                            : ''
                        "
                      >
                      </multiselect>
                      <p
                        v-if="errorFields.indexOf('additionalReqOrDoc') >= 0"
                        class="text-danger error-text mb-0 mt-1"
                      >
                        Tidak boleh kosong
                      </p>
                    </div>
                  </div>
                  <hr />
                  <div class="row w-100 align-items-center mb-2">
                    <label class="col-4">Deposit</label>
                    <div class="col-8 order_tag_input" style="gap: 10px">
                      <multiselect
                        v-model="depositValue"
                        :options="depositOptions"
                        label="label"
                        select-label=""
                        deselect-label=""
                        :allow-empty="false"
                        track-by="tagId"
                        placeholder="-"
                        @select="($event) => handleSelect($event, 'deposit')"
                        :style="
                          errorFields.indexOf('deposit') >= 0
                            ? 'border: 1px solid red; border-radius:5px'
                            : ''
                        "
                      >
                      </multiselect>
                      <p
                        v-if="errorFields.indexOf('deposit') >= 0"
                        class="text-danger error-text mb-0 mt-1"
                      >
                        Tidak boleh kosong
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  v-if="hasActiveInvoice && !permissions.includes('2.5')"
                  class="finance-field-overlay"
                >
                  <img src="~@/assets/icon/danger-octagon.svg" />
                </div>
              </div>
            </div>

            <div
              v-if="action === 'sendInvoice' || action === 'renewInvoiceExtend'"
              class="border rounded mb-2"
            >
              <div class="px-4 py-2 border-bottom bg-light rounded-top">
                <div class="d-flex" style="gap: 10px">
                  <img src="~@/assets/icon/card-check.svg" />
                  <h5 class="modal-title black-text" style="font-weight: bold">
                    Send Invoice
                  </h5>
                </div>
              </div>
              <div class="px-4 py-2">
                <h6 class="my-3" style="font-weight: 700">
                  Are you sure to process send invoice?
                </h6>
                <div class="row w-100 align-items-center">
                  <label class="col-4">Send Invoice Date</label>
                  <div class="col-8 order_tag_input pr-0" style="gap: 10px">
                    <date-picker
                      :style="`width: 100%; ${
                        errorFields.indexOf('sendInvoiceDate') >= 0
                          ? 'border: 1px solid red; border-radius:5px'
                          : ''
                      }`"
                      v-model="sendInvoiceDate"
                      type="datetime"
                      :min="minDate"
                      format="DD-MM-YYYY HH:mm:ss"
                      placeholder="Select Date and Time"
                      @change="handleSendInvoiceDateChange($event)"
                    ></date-picker>
                    <p
                      v-if="errorFields.indexOf('sendInvoiceDate') >= 0"
                      class="text-danger error-text mb-0 mt-1"
                    >
                      Tidak boleh kosong
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="isInputFieldEmpty">
              <p class="mb-0" style="color: red; font-size: 12px">
                * Semua field wajib diisi
              </p>
            </div>
            <div v-if="isInputFieldError">
              <p class="mt-0" style="color: red; font-size: 12px">
                * Terdapat input field yang tidak sesuai
              </p>
            </div>
            <div>
              <div
                v-if="!hasActiveInvoice || permissions.includes('2.5')"
                class="p-2 d-flex align-items-start"
                :style="`
                  background-color: #ffebcc;
                  border-radius: 0.625rem;
                  gap: 10px;`"
              >
                <img
                  src="~@/assets/icon/mingcute_warning-line.svg"
                  alt="warning_ic"
                  style="width: 1rem; margin-top: 2px"
                />
                <p style="font-size: 0.875rem; margin: 0">
                  Semua perubahan pada Tag akan mempengaruhi Invoice Scheduler
                  yang sedang berjalan. Mohon dipastikan data yang dimasukkan
                  sesuai kebutuhan.
                </p>
              </div>
              <div
                v-if="hasActiveInvoice && !permissions.includes('2.5')"
                class="p-2 mt-2 d-flex align-items-start"
                :style="`
                  background-color: #e74c3c;
                  border-radius: 0.625rem;
                  gap: 10px;`"
              >
                <img
                  src="~@/assets/icon/mingcute_warning-line-white.svg"
                  alt="warning_ic"
                  style="width: 1.1rem; margin-top: 2px"
                />
                <p style="font-size: 0.875rem; margin: 0; color: #fff">
                  Sudah ada invoice aktif, tidak bisa ubah tag. Untuk mengubah,
                  silahkan hapus invoice terlebih dahulu.
                </p>
              </div>
            </div>
          </div>
        </div>
        <preview-payment
          v-else
          :orderData="orderData"
          :previewPaymentData="previewPaymentData"
          @generate-preview-payment="fetchPreviewPayment"
        />
        <div class="modal-footer d-flex justify-content-between">
          <div>
            <button
              v-if="!isLoadingSubmit && currentStep > 1"
              class="btn btn-small btn-white mt-3"
              @click="currentStep--"
            >
              <i class="fas fa-arrow-left"></i>
              <span class="ml-1">Back</span>
            </button>
          </div>
          <div style="text-align: right">
            <button
              v-if="!isLoadingSubmit"
              class="btn btn-small btn-primary mt-3"
              @click="submitOrderTag"
            >
              {{ submitButtonText }}
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              disabled
              v-else
            >
              <img src="~@/assets/images/2.gif" style="height: 24px" />Saving
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import swal from "sweetalert";
import Multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";
import moment, { duration, min } from "moment";
import Swal2 from "sweetalert2";
import PreviewPayment from "./PreviewPayment.vue";

export default {
  name: "ModalEditInvoiceTag",
  components: {
    Multiselect,
    DatePicker,
    PreviewPayment,
  },
  props: {
    companyId: Number,
    orderId: Number,
    action: String,
    getOrderData: Function,
    isOpen: Boolean,
    orderData: Object || null,
    orderStatus: {
      type: Number,
      default: 0,
      required: false,
    },
  },
  data() {
    return {
      minDate: moment().format("YYYY-MM-DD"),
      billingValue: null,
      billingOptions: [],
      recurringBillingDayOptions: [],
      recurringBillingDayValue: null,
      dueDateOptions: [],
      dueDateValue: null,
      billingStartOptions: [],
      billingStartValue: null,
      upfrontOptions: [],
      upfrontValue: null,
      billingCalculationOptions: [],
      billingCalculationValue: null,
      invoiceTypeOptions: [],
      invoiceTypeValue: null,
      billedPerOptions: [],
      billedPerValue: null,
      additionalReqOrDocOptions: [],
      additionalReqOrDocValue: null,
      depositOptions: [],
      depositValue: null,
      billingDate: null,
      billingDate10: null,
      customDueDate: null,
      customRecurringBillingDay: null,
      salesForm: [],
      isLoadingSubmit: false,
      errorFields: [],
      isFinishGetDetail: false,
      isFinishGetForm: false,
      tagFormData: null,
      orderTagDetailData: {
        customDueDate: null,
        customRecurringBillingDay: null,
        billingDate: null,
        billingDate10: null,
        billingDate90: null,
        billingDate100: null,
        tags: [],
      },
      tagsAttributes: [
        "additionalReqOrDoc",
        "billedPer",
        "billingCalculation",
        "billingStart",
        "billing",
        "deposit",
        "dueDate",
        "invoiceType",
        "recurringBillingDay",
        "upfront",
      ],
      billingTooltip: "",
      dueDateTooltip: "",
      billingCalculationTooltip: "",
      billedPerTooltip: "",
      recurringBillingDayTooltip: "",
      billingStartTooltip: "",
      hasActiveInvoice: false,
      sendInvoiceDate: new Date(),
      isTagExist: false,

      // tags
      tagAfterUsage: 204,
      tagBillingCalcStandard: 160,
      tagMonthly: 5,

      currentStep: 1,
      previewPaymentData: [],
      currentParsedTags: [],
    };
  },
  computed: {
    permissions() {
      const roles = JSON.parse(localStorage.getItem("roles"));
      if (!roles || roles.length === 0) {
        return [];
      }
      return roles;
    },
    modalTitle() {
      if (!this.isFinishGetDetail) return "Memuat...";
      if (this.isTagExist) return "Review Tag";
      return "Edit Tag";
    },
    submitButtonText() {
      if (this.currentStep === 1) return "Next";
      if (this.action === "sendInvoice" || this.action === "renewInvoiceExtend")
        return "Simpan";

      return "Update";
    },
    isInputFieldEmpty() {
      if (this.errorFields.length > 0) {
        const emptiedFields = this.errorFields.filter((el) => {
          return (
            el !== "billingDateBackdated" &&
            el !== "billingDate10Backdated" &&
            el !== "billingTagError"
          );
        });
        if (emptiedFields.length > 0) return true;
      }
      return false;
    },
    isInputFieldError() {
      if (this.errorFields.length > 0) {
        const errorFields = this.errorFields.filter((el) => {
          return (
            el === "billingDateBackdated" ||
            el === "billingDate10Backdated" ||
            el === "billingTagError"
          );
        });
        if (errorFields.length > 0) return true;
      }
      return false;
    },
  },
  methods: {
    disabledDate(date) {
      const todayDate = new Date().setHours(0, 0, 0, 0);
      return date < todayDate;
    },
    handleChangeInput(value, type) {
      if (this.errorFields.length > 0) {
        this.errorFields = this.errorFields.filter((el) => el != type);
      }
      if (
        type === "billingDate" &&
        value &&
        !moment(value).isBefore(moment(), "day")
      ) {
        this.errorFields = this.errorFields.filter(
          (el) => el != "billingDateBackdated"
        );
      }
      if (
        type === "billingDate10" &&
        value &&
        !moment(value).isBefore(moment(), "day")
      ) {
        this.errorFields = this.errorFields.filter(
          (el) => el != "billingDate10Backdated"
        );
      }
    },
    handleSendInvoiceDateChange(event) {
      if (this.errorFields.indexOf("sendInvoiceDate") >= 0) {
        this.errorFields = this.errorFields.filter(
          (el) => el != "sendInvoiceDate"
        );
      }
    },
    handleRemove(value, type) {
      this[type + "Value"] = this[type + "Value"].filter((el) => {
        return el.tagId !== value.tagId;
      });
      if (type === "billing" && this.billingValue) {
        if (
          this.billingValue.length > 1 &&
          this.billingValue.findIndex((el) => el.tagId === 152) < 0
        ) {
          this.errorFields = this.errorFields.filter(
            (el) => el != "billingTagError"
          );
        }
        if (this.billingValue.length === 1) {
          this.errorFields = this.errorFields.filter(
            (el) => el != "billingTagError"
          );
        }
      }
    },
    handleSelect(value, type) {
      /**
       * Validasi kombinasi tag "After Usage" dengan tag "Standard" 
       * pada field "Billing Start" dan "Billing Calculation". 
       * 
        - Jika user memilih tag "After Usage" pada field "Billing Start", 
          maka tag "Standard" pada field "Billing Calculation" 
          tidak bisa dipilih, dan sebaliknya.
       */
      if (type === "billingStart" && value.tagId === this.tagAfterUsage) {
        if (this.billingCalculationValue.tagId == this.tagBillingCalcStandard) {
          return swal(
            "Maaf",
            'Tag "After Usage" tidak bisa dikombinasikan dengan tag "Standard". Hilangkan tag "Standard" untuk melakukan kombinasi tag "After Usage".',
            "error",
            {
              button: "Ok",
            }
          );
        }
      }

      if (type === "billingCalculation" && this.billingStartValue) {
        if (
          this.billingStartValue.tagId == this.tagAfterUsage &&
          value.tagId === this.tagBillingCalcStandard
        ) {
          return swal(
            "Maaf",
            'Tag "After Usage" tidak bisa dikombinasikan dengan tag "Standard". Hilangkan tag "Standard" untuk melakukan kombinasi tag "After Usage".',
            "error",
            {
              button: "Ok",
            }
          );
        }
        if (this.orderStatus === 13 && this.hasActiveInvoice) {
          return swal(
            "Maaf",
            "Tidak bisa mengganti Tag Billing Calculation ketika invoice sudah ditagihkan",
            "error",
            {
              button: "Ok",
            }
          );
        }
      }
      // Batas akhir validasi kombinasi tag "After Usage" dengan tag "Standard"

      if (type === "billing" && this.billingValue) {
        const dashedIndexValue = this.billingValue.findIndex(
          (el) => el.tagId === 152
        );
        if (dashedIndexValue >= 0 && value.tagId !== 152) {
          return swal(
            "Maaf",
            'Tag "-" tidak bisa dikombinasikan dengan tag lain. Hilangkan tag "-" untuk melakukan kombinasi tag lainnya',
            "error",
            {
              button: "Ok",
            }
          );
        }
        const dataOtherThanDash = this.billingValue.filter(
          (el) => el.tagId !== 152
        );
        if (value.tagId === 152 && dataOtherThanDash.length > 0) {
          return swal(
            "Maaf",
            'Tag "-" tidak bisa dikombinasikan dengan tag lain. Hilangkan tag "-" untuk melakukan kombinasi tag lainnya.',
            "error",
            {
              button: "Ok",
            }
          );
        }
        this.billingValue.push(value);
        this.errorFields = this.errorFields.filter(
          (el) => el != "billingTagError"
        );
      }

      if (
        this.orderData &&
        this.orderData.ltCode &&
        type === "billedPer" &&
        value.tagId !== this.tagMonthly
      ) {
        return swal(
          "Error Tag " + value.label,
          "Order HANYA bisa menggunakan tag Monthly Invoice " +
            `(${this.orderData.ltCode})`,
          "error",
          {
            button: "Ok",
          }
        );
      }
      if (this.errorFields.length > 0) {
        this.errorFields = this.errorFields.filter((el) => el != type);
      }
      switch (type) {
        case "billedPer":
          this.billedPerValue = value;
          if (value.tagId !== 167) {
            this.upfrontValue = null;
            this.billingDate = null;
            this.billingDate10 = null;
          } else {
            this.customRecurringBillingDay = null;
            this.billingStartValue = null;
            this.recurringBillingDayValue = null;
            this.billingCalculationValue = null;
            if (this.errorFields.length > 0) {
              this.errorFields = this.errorFields.filter(
                (el) =>
                  el != "billingStart" &&
                  el != "billingCalculation" &&
                  el != "recurringBillingDay"
              );
            }
          }
          break;
        case "dueDate":
          this.customDueDate = null;
          break;
        case "recurringBillingDay":
          this.customRecurringBillingDay = null;
          break;
        case "billingStart":
          this.billingStartValue = value;
          break;
        case "billingCalculation":
          this.billingCalculationValue = value;
          break;

        default:
          break;
      }
    },
    isAllowedToSubmitBasedOnPermission(data) {
      return new Promise(async (resolve) => {
        try {
          // Check if the finance tag data has been edited
          const isFinanceDataEdited = await this.isEditedFinanceData(data);
          if (!isFinanceDataEdited) {
            resolve(true);
            return;
          }
          const swal = Swal2.mixin({
            customClass: {
              confirmButton: "btn btn-primary rounded-lg font-weight-bolder",
              cancelButton:
                "btn bg-white border mr-4 rounded-lg font-weight-bolder border-radius-20",
            },
            reverseButtons: true,
            buttonsStyling: false,
          });

          // Validate if the user has an active invoice and does not have permission to change tags
          if (!this.permissions.includes("2.5")) {
            swal(
              "Maaf",
              "Anda tidak memiliki akses untuk mengubah tag Finance pada invoice aktif.",
              "error",
              {
                button: "Ok",
              }
            );
            resolve(false);
            return;
          }

          const response = await swal.fire({
            title: "Apakah Anda yakin?",
            text: "Tag Order ini akan diperbarui dan pastikan kembali pembaruan Anda sudah sesuai.",
            icon: "warning",
            confirmButtonColor: "#3098F7",
            cancelButtonText: "Batal",
            confirmButtonText: "Update Tag",
            showCancelButton: true,
          });
          if (response.isDismissed) {
            resolve(false);
            return;
          }

          resolve(true);
        } catch (error) {
          resolve(false);
        }
        return;
      });
    },
    async submitOrderTag() {
      this.validateForm();
      if (this.errorFields.length <= 0) {
        const sentData = {
          action: this.action,
          orderId: this.orderId,
          companyId: this.companyId,
        };
        if (
          this.action === "sendInvoice" ||
          this.action === "renewInvoiceExtend"
        ) {
          sentData.invoiceTime = moment(this.sendInvoiceDate).format(
            "YYYY-MM-DDTHH:mm:ss"
          );
        }
        const tags = [];
        this.tagsAttributes.forEach((el) => {
          const value = this[`${el}Value`];
          if (el === "billing" && value) {
            value.forEach((el) => {
              tags.push({
                tagId: el.tagId,
                label: el.label,
                value: el.value,
              });
            });
          } else if (value) {
            tags.push({
              tagId: value.tagId,
              label: value.label,
              value: value.value,
            });
          }
        });
        this.salesForm.forEach((el) => {
          if (el.selected) {
            el.selected.forEach((item) => {
              tags.push({
                label: item.label,
                tagId: item.tagId,
                value: item.value,
              });
            });
          }
        });
        if (this.currentStep === 1) {
          this.currentStep++;
          this.currentParsedTags = tags;
          const startRent =
            this.orderData && this.orderData.startRent
              ? this.orderData.startRent.split("-").reverse().join("-")
              : null;
          this.fetchPreviewPayment({
            startRent: startRent,
            duration: this.orderData ? this.orderData.duration : null,
          });
          return;
        }
        sentData.tags = tags;
        if (this.customDueDate) {
          sentData.customDueDate = parseInt(this.customDueDate);
        }
        if (this.customRecurringBillingDay) {
          sentData.customRecurringBillingDay = parseInt(
            this.customRecurringBillingDay
          );
        }
        if (this.billingDate) {
          sentData[
            `billingDate${this.upfrontValue.tagId === 7 ? "100" : "90"}`
          ] = moment(this.billingDate).format("YYYY-MM-DD");
        }
        if (this.billingDate10) {
          sentData.billingDate10 = moment(this.billingDate10).format(
            "YYYY-MM-DD"
          );
        }

        if (this.isHaveActiveInvoice) {
          try {
            const isAllowed = await this.isAllowedToSubmitBasedOnPermission(
              sentData
            );
            if (!isAllowed) {
              return;
            }
          } catch (error) {
            return swal(
              "Maaf",
              "Terjadi kesalahan saat memeriksa izin.",
              "error",
              {
                button: "Ok",
              }
            );
          }
        }

        this.compareEditedData(sentData)
          .then((_) => {
            this.isLoadingSubmit = true;
            this.$http
              .post(process.env.SEND_ORDER_TAG, sentData, {
                headers: { "Asani-Token": localStorage.getItem("jwt") },
                timeout: 60000,
              })
              .then((response) => {
                this.isLoadingSubmit = false;
                if (response.data.status !== 200) {
                  swal("Sorry", response.data.message, "error", {
                    button: "Ok",
                  });
                } else {
                  $("#modalEditOrderTag").modal("hide");
                  if (this.action === "listOrder") this.$emit("get-order-tags");
                  this.closeModal("submit", true);
                }
              })
              .catch((error) => {
                this.isLoadingSubmit = false;
                swal("Sorry", error.response.data.message, "error", {
                  button: "Ok",
                }).then((v) => {
                  if (error.response.data.status == 401) {
                    this.handleLogout();
                  }
                });
              });
          })
          .catch((err) => {
            this.closeModal("submit", false);
          });
      }
    },
    async isEditedFinanceData(data) {
      let salesTag = [];
      function mapChildTag(child) {
        if (child.value && child.value.length > 0) {
          salesTag = [
            ...salesTag,
            ...child.value.map((el) => {
              if (el.child && el.child.length > 0) {
                mapChildTag(el.child);
              }
              return el.tagId;
            }),
          ];
        }
        return null;
      }

      this.tagFormData
        .find((el) => el.parent === "Sales")
        .child.forEach((el) => {
          mapChildTag(el);
        });

      let result = false;
      const {
        tags,
        customDueDate,
        customRecurringBillingDay,
        billingDate100,
        billingDate90,
        billingDate10,
      } = this.orderTagDetailData;
      const prevData = {
        customDueDate: customDueDate ? customDueDate : undefined,
        customRecurringBillingDay: customRecurringBillingDay
          ? customRecurringBillingDay
          : undefined,
        billingDate: billingDate100
          ? billingDate100
          : billingDate90
          ? billingDate90
          : undefined,
        billingDate10: billingDate10 ? billingDate10 : undefined,
        tags: tags.filter((el) => !salesTag.includes(el)).sort((a, b) => a - b),
      };
      const currentData = {
        customDueDate: data.customDueDate,
        customRecurringBillingDay: data.customRecurringBillingDay,
        billingDate: data.billingDate90
          ? data.billingDate90
          : data.billingDate100,
        billingDate10: data.billingDate10,
        tags: data.tags
          .map((el) => el.tagId)
          .filter((el) => !salesTag.includes(el))
          .sort((a, b) => a - b),
      };
      if (JSON.stringify(prevData) !== JSON.stringify(currentData)) {
        result = true;
      }
      return Promise.resolve(result);
    },
    // This validation is for when the user not editing any input field, so need to check if it edited, it will send data to BE
    async compareEditedData(data) {
      if (this.action === "sendInvoice" || this.action === "renewInvoiceExtend")
        return Promise.resolve();
      let result = false;
      const {
        tags,
        customDueDate,
        customRecurringBillingDay,
        billingDate100,
        billingDate90,
        billingDate10,
      } = this.orderTagDetailData;
      const prevData = {
        customDueDate: customDueDate ? customDueDate : undefined,
        customRecurringBillingDay: customRecurringBillingDay
          ? customRecurringBillingDay
          : undefined,
        billingDate: billingDate100
          ? billingDate100
          : billingDate90
          ? billingDate90
          : undefined,
        billingDate10: billingDate10 ? billingDate10 : undefined,
        tags: tags.sort((a, b) => a - b),
      };
      const currentData = {
        customDueDate: data.customDueDate,
        customRecurringBillingDay: data.customRecurringBillingDay,
        billingDate: data.billingDate90
          ? data.billingDate90
          : data.billingDate100,
        billingDate10: data.billingDate10,
        tags: data.tags.map((el) => el.tagId).sort((a, b) => a - b),
      };
      if (JSON.stringify(prevData) !== JSON.stringify(currentData)) {
        result = true;
      }
      return new Promise((resolve, reject) => {
        if (result) {
          resolve();
        } else {
          reject();
        }
      });
    },
    closeModal(type, isSuccess) {
      this.isFinishGetDetail = false;
      this.isFinishGetForm = false;
      this.errorFields = [];
      this.customDueDate = null;
      this.billingDate10 = null;
      this.customRecurringBillingDay = null;
      this.billingDate = null;
      this.orderTagDetailData = {
        customDueDate: null,
        customRecurringBillingDay: null,
        lastBillingDate: null,
        billingDate10: null,
        tags: [],
      };

      this.tagsAttributes.forEach((el) => {
        if (this[`${el}Value`]) {
          this[`${el}Value`] = null;
        }
      });
      this.$emit("req-close", type, isSuccess);
      this.salesForm.forEach((el) => {
        el.selected = null;
      });
      $(`#modalEditInvoiceTag`).modal("hide");
      this.currentStep = 1;
    },
    validateForm() {
      const errorFields = [];

      if (
        (this.action === "sendInvoice" ||
          this.action === "renewInvoiceExtend") &&
        !this.sendInvoiceDate
      ) {
        errorFields.push("sendInvoiceDate");
      }

      this.salesForm.forEach((el) => {
        if (!el.selected) {
          errorFields.push(el.name);
        }
      });

      if (!this.billingValue || this.billingValue.length === 0) {
        errorFields.push("billing");
      }
      if (this.billingValue && this.billingValue.length > 0) {
        const hasDash = this.billingValue.findIndex((el) => el.tagId === 152);
        if (hasDash >= 0 && this.billingValue.length > 1) {
          errorFields.push("billingTagError");
        }
      }
      if (!this.dueDateValue) {
        errorFields.push("dueDate");
      } else {
        if (this.dueDateValue.tagId === 159 && !this.customDueDate) {
          errorFields.push("customDueDate");
        }
      }
      if (!this.billedPerValue) {
        errorFields.push("billedPer");
      }
      if (this.billedPerValue && this.billedPerValue.tagId === 167) {
        if (!this.upfrontValue) {
          errorFields.push("upfront");
        }
        if (!this.billingDate) {
          errorFields.push("billingDate");
        } else {
          // Check whether the billingDate is before the current date
          if (moment(this.billingDate).isBefore(moment(), "day")) {
            errorFields.push("billingDateBackdated");
          }
        }
        if (this.upfrontValue && this.upfrontValue.tagId === 16) {
          if (!this.billingDate10) {
            errorFields.push("billingDate10");
          } else {
            // Check whether the billingDate10 is before the current date
            if (moment(this.billingDate10).isBefore(moment(), "day")) {
              errorFields.push("billingDate10Backdated");
            }
          }
        }
      }
      if (!this.billedPerValue || this.billedPerValue.tagId !== 167) {
        if (!this.recurringBillingDayValue) {
          errorFields.push("recurringBillingDay");
        } else {
          if (
            this.recurringBillingDayValue.tagId === 164 &&
            !this.customRecurringBillingDay
          ) {
            errorFields.push("customRecurringBillingDay");
          }
        }
        if (!this.billingStartValue) {
          errorFields.push("billingStart");
        }
        if (!this.billingCalculationValue) {
          errorFields.push("billingCalculation");
        }
      }
      if (!this.depositValue) {
        errorFields.push("deposit");
      }
      if (!this.invoiceTypeValue) {
        errorFields.push("invoiceType");
      }
      if (!this.additionalReqOrDocValue) {
        errorFields.push("additionalReqOrDoc");
      }
      this.errorFields = errorFields;
    },
    parseOptionValue(option, currentTags, key) {
      option.forEach((item) => {
        if (currentTags.findIndex((val) => val === item.tagId) >= 0) {
          this[key] = item;
        }
      });
    },
    handleMapOrderTagData() {
      const {
        customDueDate,
        customRecurringBillingDay,
        billingDate10,
        billingDate100,
        billingDate90,
        tags,
      } = this.orderTagDetailData;
      const tagsData = tags ? tags : [];
      if (customDueDate) {
        this.customDueDate = customDueDate;
      }
      if (customRecurringBillingDay) {
        this.customRecurringBillingDay = customRecurringBillingDay;
      }
      if (billingDate100 || billingDate90) {
        this.billingDate = billingDate100
          ? new Date(billingDate100)
          : new Date(billingDate90);
      }
      if (billingDate10) {
        this.billingDate10 = new Date(billingDate10);
      }
      if (this.tagFormData) {
        this.tagFormData.forEach((item) => {
          if (item.parent.toLowerCase() !== "finance") {
            this.salesForm =
              !item.child && this.salesForm.length > 0
                ? this.salesForm
                : item.child.map((el) => {
                    const selectedData = el.value.reduce((curr, val) => {
                      if (tagsData.findIndex((el) => el === val.tagId) >= 0)
                        return [...curr, val];
                      return curr;
                    }, []);
                    return {
                      ...el,
                      selected: selectedData.length > 0 ? selectedData : null,
                    };
                  });
          } else {
            item.child.forEach((el) => {
              switch (el.idChild) {
                case 2:
                  this.billingOptions = el.value;
                  const selectedData = el.value.reduce((curr, val) => {
                    if (tagsData.findIndex((el) => el === val.tagId) >= 0)
                      return [...curr, val];
                    return curr;
                  }, []);
                  this.billingValue = selectedData;
                  this.billingTooltip = el.tooltip;
                  break;
                case 17:
                  this.recurringBillingDayOptions = el.value;
                  this.parseOptionValue(
                    el.value,
                    tagsData,
                    "recurringBillingDayValue"
                  );
                  this.recurringBillingDayTooltip = el.tooltip;
                  break;
                case 9:
                  this.dueDateOptions = el.value;
                  this.parseOptionValue(el.value, tagsData, "dueDateValue");
                  this.dueDateTooltip = el.tooltip;
                  break;
                case 18:
                  this.billingStartOptions = el.value;
                  this.parseOptionValue(
                    el.value,
                    tagsData,
                    "billingStartValue"
                  );
                  this.billingStartTooltip = el.tooltip;
                  break;
                case 15:
                  this.billingCalculationOptions = el.value;
                  this.parseOptionValue(
                    el.value,
                    tagsData,
                    "billingCalculationValue"
                  );
                  this.billingCalculationTooltip = el.tooltip;
                  break;
                case 10:
                  this.invoiceTypeOptions = el.value;
                  this.parseOptionValue(el.value, tagsData, "invoiceTypeValue");
                  break;
                case 16:
                  this.billedPerOptions = el.value;
                  this.parseOptionValue(el.value, tagsData, "billedPerValue");
                  const upfrontOption = el.value.find((el) => el.tagId === 167);
                  this.upfrontOptions = upfrontOption.child;
                  this.parseOptionValue(
                    upfrontOption.child,
                    tagsData,
                    "upfrontValue"
                  );
                  this.billedPerTooltip = el.tooltip;
                  break;
                case 11:
                  this.additionalReqOrDocOptions = el.value;
                  this.parseOptionValue(
                    el.value,
                    tagsData,
                    "additionalReqOrDocValue"
                  );
                  break;
                case 12:
                  this.depositOptions = el.value;
                  this.parseOptionValue(el.value, tagsData, "depositValue");
                  break;
                default:
                  break;
              }
            });
          }
        });
      }
    },
    getTagForm() {
      this.isFinishGetForm = false;
      this.$http
        .get(process.env.GET_TAG_FORM, {
          headers: { "Asani-Token": localStorage.getItem("jwt") },
        })
        .then((response) => {
          this.isFinishGetForm = true;
          if (response.data.status === 200 && response.data.data.length > 0) {
            this.tagFormData = response.data.data;
          }
        })
        .catch((error) => {
          this.isFinishGetForm = true;
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then((v) => {
            if (error.response.data.status == 401) {
              this.handleLogout();
            }
          });
        });
    },
    getOrderTagDetail(value) {
      this.isFinishGetDetail = false;
      this.$http
        .get(process.env.GET_ORDER_TAG + `/${value}`, {
          headers: { "Asani-Token": localStorage.getItem("jwt") },
        })
        .then((response) => {
          this.isFinishGetDetail = true;
          if (response.data.status === 200) {
            this.isTagExist = true;
            this.orderTagDetailData = response.data.content;
            this.hasActiveInvoice = response.data.content.isHaveActiveInvoice;
          }
        })
        .catch((error) => {
          this.isFinishGetDetail = true;
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then((v) => {
            if (error.response.data.status == 401) {
              this.handleLogout();
            }
          });
        });
    },
    async fetchPreviewPayment({ startRent, duration }) {
      const startRentDate = moment(startRent, "YYYY-MM-DD").format(
        "YYYY-MM-DD"
      );
      const customRecurringBillingDay = this.customRecurringBillingDay
        ? Number(this.customRecurringBillingDay)
        : 0;
      const payload = {
        orderId: this.orderData.orderId,
        startRent: startRentDate === "Invalid date" ? null : startRentDate,
        duration: duration ? Number(duration || 12) : null,
        customRecurringBillingDay,
        billingDate10: "",
        billingDate90: "",
        billingDate100: "",
        tags: this.currentParsedTags || [],
      };
      if (this.billingDate10) {
        payload.billingDate10 = moment(this.billingDate10).format("YYYY-MM-DD");
      }

      if (this.billingDate) {
        if (this.upfrontValue.tagId === 7) {
          payload.billingDate100 = moment(this.billingDate).format(
            "YYYY-MM-DD"
          );
        } else {
          payload.billingDate90 = moment(this.billingDate).format("YYYY-MM-DD");
        }
      }
      try {
        const response = await this.$http.post(
          process.env.PREVIEW_ORDER_PAYMENT_SCHEMA,
          payload,
          {
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        );
        if (response.data.status !== 200) {
          console.error(
            "Error fetching payment schedule:",
            response.data.message
          );
          return;
        }
        this.previewPaymentData = response.data.content.payments;
      } catch (error) {
        console.error("Error fetching payment schedule:", error);
      }
    },
  },
  watch: {
    billingValue(newVal) {
      if (newVal.length > 0) {
        const dashedIndexValue = newVal.findIndex((el) => el.tagId === 152);
        if (dashedIndexValue >= 0) {
          this.billingOptions = this.billingOptions.map((el) => ({
            ...el,
            $isDisabled: el.tagId === 152 ? false : true,
          }));
        }
        if (dashedIndexValue < 0) {
          this.billingOptions = this.billingOptions.map((el) => ({
            ...el,
            $isDisabled: el.tagId === 152 ? true : false,
          }));
        }
      } else {
        this.billingOptions = this.billingOptions.map((el) => ({
          ...el,
          $isDisabled: false,
        }));
      }
    },
    isOpen(newVal, oldVal) {
      if (newVal) {
        this.getOrderTagDetail(this.orderId);
        this.getTagForm();
        this.sendInvoiceDate = new Date();
      }
    },
  },
  mounted() {
    this.$watch(
      (vm) => [vm.isFinishGetDetail, vm.isFinishGetForm],
      (newVal) => {
        if (newVal[0] && newVal[1]) {
          this.handleMapOrderTagData();
        }
      }
    );
  },
  created() {},
};
$(document).ready(function () {
  var self = this;
  $('[data-toggle="tooltip"]').tooltip();
});
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url("https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.min.css");
@import url("https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap");

.btn-primary {
  background: #2678e8;
  font-size: 14px;
}

.btn-white {
  background: #ffffff;
  font-size: 14px;
  color: #2e3646;
  border: 1px solid #d1d9e2;
  font-weight: 600;
}

.btn {
  border-radius: 8px;
}

.disabled_option {
  background-color: #5d6575;
  cursor: not-allowed;
}

.inter-font {
  font-family: "Inter", serif;
  font-optical-sizing: auto;
  font-weight: 400;
  font-style: normal;
}

label {
  font-weight: 600;
  font-size: 14px;
  margin-top: 12px;
}

.text-grey {
  color: #5d6575;
}

.error-text {
  font-size: 12px;
}

.border-error {
  border: 1px solid red;
}

.finance-field-container {
  position: relative;
}
.finance-field-overlay {
  top: 0;
  left: 0;
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0);
  transition: all 200ms;
  display: flex;
  justify-content: center;
  align-items: center;
}

.finance-field-overlay img {
  width: 100px;
  height: 100px;
  transition: all 200ms;
  opacity: 0;
}
.finance-field-container:hover .finance-field-overlay {
  background-color: rgba(0, 0, 0, 0.5);
}

.finance-field-container:hover .finance-field-overlay img {
  opacity: 1;
}

.e-multiselect.e-input-group .e-multi-select-wrapper {
  background-color: red;
}

/* Chrome, Safari, Edge, Opera */
.input_number input::-webkit-outer-spin-button,
.input_number input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
.input_number input[type="number"] {
  -moz-appearance: textfield;
}

::-webkit-datetime-edit-year-field:not([aria-valuenow]),
::-webkit-datetime-edit-month-field:not([aria-valuenow]),
::-webkit-datetime-edit-day-field:not([aria-valuenow]) {
  color: transparent;
}
.finance_tag_grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.check-box-text {
  color: #2e3646;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 125% */
  letter-spacing: -0.016px;
}

.most-overdue-title {
  color: #000;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px; /* 157.143% */
  letter-spacing: -0.014px;
}

.most-overdue-text {
  color: #2e3646;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px; /* 157.143% */
  letter-spacing: -0.014px;
}

.most-overdue-orange {
  color: #ff5252;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px; /* 157.143% */
  letter-spacing: -0.014px;
}

@media (max-width: 767px) {
  .nav-side-menu {
    position: relative;
    width: 100%;
    margin-bottom: 10px;
  }
  .nav-side-menu .toggle-btn {
    display: block;
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 10 !important;
    padding: 3px;
    background-color: #ffffff;
    color: #000;
    width: 40px;
    text-align: center;
  }
  .brand {
    text-align: left !important;
    font-size: 22px;
    padding-left: 20px;
    line-height: 50px !important;
  }
}
@media (min-width: 767px) {
  .nav-side-menu .menu-list .menu-content {
    display: block;
  }
}
@media (max-width: 573px) {
  .mobile-div {
    padding: 2px 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Order/CustomComponent/ModalEditInvoiceTag.vue